export default "__VITE_ASSET__ClKrBoo5__"